import { Box, Text } from '@chakra-ui/react';

export function InfoField({ label, value }: { label: string; value?: string | null }) {
  if (!value) return null
  return (
    <Box>
      <Text fontSize="xs" color="gray.500" fontWeight="medium">{label}</Text>
      <Text fontSize="sm">{value}</Text>
    </Box>
  )
}

export function formatDate(dateStr?: string) {
  if (!dateStr) return null
  const d = new Date(dateStr)
  return d.toLocaleDateString(undefined, { timeZone: 'UTC' })
}

export function formatContractPeriod(start?: string, end?: string) {
  const s = formatDate(start)
  const e = formatDate(end)
  if (!s && !e) return '---'
  return `${s || '?'} → ${e || 'Present'}`
}
